'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineCheckboxField = exports.InlineEditField = exports.BuyoutField = undefined;

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2, _dec, _class4, _desc2, _value2, _class5, _descriptor2, _class6, _temp4, _dec2, _class7, _class8, _temp5;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../../common/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _EmptyStateButton = require('../../common/EmptyStateButton');

var _EmptyStateButton2 = _interopRequireDefault(_EmptyStateButton);

var _utils = require('../../../utils');

var _PriorFundingModal = require('../../common-prior-fundings/PriorFundingModal');

var _PriorFundingModal2 = _interopRequireDefault(_PriorFundingModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getOrDefault = _utils.FormattingUtils.getOrDefault,
    formatDate = _utils.FormattingUtils.formatDate;

var InlineEditField = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(InlineEditField, _Component);

  function InlineEditField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InlineEditField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InlineEditField.__proto__ || Object.getPrototypeOf(InlineEditField)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isEditing', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InlineEditField, [{
    key: 'onBlur',
    value: function onBlur(e) {
      var _props = this.props,
          onCaseApplicationChanged = _props.onCaseApplicationChanged,
          application = _props.application,
          fieldName = _props.fieldName,
          value = _props.value;

      var newValue = parseFloat(e.target.value);

      var isInvalidOrNegativeValue = isNaN(newValue) || newValue < 0;
      if (isInvalidOrNegativeValue) {
        newValue = 0;
      }

      if (value !== newValue) {
        onCaseApplicationChanged(application, _defineProperty({}, fieldName, newValue), application.type);
      }
      this.isEditing = false;
    }
  }, {
    key: 'toggleEdit',
    value: function toggleEdit() {
      this.isEditing = !this.isEditing;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          label = _props2.label,
          value = _props2.value,
          formatter = _props2.formatter,
          inputType = _props2.inputType,
          formattedValue = formatter ? formatter(value) : value;


      return _react2.default.createElement(
        _Col2.default,
        { xs: 6, className: 'inline-edit' },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-label', xs: 4 },
            getOrDefault(label)
          ),
          !this.isEditing ? _react2.default.createElement(
            _Col2.default,
            { className: 'col-value', xs: 8 },
            getOrDefault(formattedValue),
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'link', className: 'btn-edit', onClick: this.toggleEdit },
              _react2.default.createElement(_Icon2.default, { type: 'pencil' })
            )
          ) : _react2.default.createElement(
            _Col2.default,
            { className: 'col-value', xs: 8 },
            _react2.default.createElement('input', { autoFocus: true, type: inputType || 'text', onBlur: this.onBlur, defaultValue: value })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return InlineEditField;
}(_react.Component), _class3.propTypes = {
  application: _propTypes2.default.object.isRequired,
  fieldName: _propTypes2.default.string,
  formatter: _propTypes2.default.func,
  inputType: _propTypes2.default.string,
  label: _propTypes2.default.string,
  onCaseApplicationChanged: _propTypes2.default.func,
  value: _propTypes2.default.string
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isEditing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class;

var BuyoutField = (_dec = (0, _mobxReact.inject)('UiStore'), _dec(_class4 = (0, _classAutobindDecorator2.default)(_class4 = (0, _mobxReact.observer)(_class4 = (_class5 = (_temp4 = _class6 = function (_Component2) {
  _inherits(BuyoutField, _Component2);

  function BuyoutField() {
    var _ref2;

    var _temp3, _this2, _ret2;

    _classCallCheck(this, BuyoutField);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = _possibleConstructorReturn(this, (_ref2 = BuyoutField.__proto__ || Object.getPrototypeOf(BuyoutField)).call.apply(_ref2, [this].concat(args))), _this2), _initDefineProp(_this2, 'modalShowing', _descriptor2, _this2), _temp3), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(BuyoutField, [{
    key: 'onEditClick',
    value: function onEditClick() {
      this.modalShowing = true;
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      this.modalShowing = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          _case = _props3._case,
          application = _props3.application,
          label = _props3.label,
          value = _props3.value,
          formatter = _props3.formatter,
          formattedValue = formatter ? formatter(value.buyout_amount) : value.buyout_amount;


      return _react2.default.createElement(
        _Col2.default,
        { xs: 6 },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-label', xs: 4 },
            getOrDefault(label)
          ),
          (0, _isEmpty3.default)(value) && _react2.default.createElement(
            _Col2.default,
            { className: 'col-value', xs: 8 },
            _react2.default.createElement(_EmptyStateButton2.default, { emptyText: 'Add Buyout', onClick: this.onEditClick })
          ),
          !(0, _isEmpty3.default)(value) && _react2.default.createElement(
            _Col2.default,
            { className: 'col-value', xs: 8 },
            getOrDefault(formattedValue),
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'link', className: 'btn-edit', onClick: this.onEditClick },
              _react2.default.createElement(_Icon2.default, { type: 'pencil' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'funder-name secondary-info ellipsis' },
              getOrDefault(value.funder_name)
            ),
            _react2.default.createElement(
              'div',
              { className: 'secondary-info' },
              _react2.default.createElement(
                'span',
                null,
                'Payoff Exp:'
              ),
              ' ',
              formatDate(value.expiration_date)
            )
          )
        ),
        this.modalShowing && _react2.default.createElement(_PriorFundingModal2.default, {
          _case: _case,
          application: application,
          onClose: this.onClose,
          priorFunding: value
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return BuyoutField;
}(_react.Component), _class6.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  application: _propTypes2.default.object.isRequired,
  formatter: _propTypes2.default.func,
  label: _propTypes2.default.string,
  value: _propTypes2.default.string
}, _temp4), (_descriptor2 = _applyDecoratedDescriptor(_class5.prototype, 'modalShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class5)) || _class4) || _class4) || _class4);
var InlineCheckboxField = (_dec2 = (0, _mobxReact.inject)('ApplicationStore'), _dec2(_class7 = (0, _classAutobindDecorator2.default)(_class7 = (0, _mobxReact.observer)(_class7 = (_temp5 = _class8 = function (_Component3) {
  _inherits(InlineCheckboxField, _Component3);

  function InlineCheckboxField() {
    _classCallCheck(this, InlineCheckboxField);

    return _possibleConstructorReturn(this, (InlineCheckboxField.__proto__ || Object.getPrototypeOf(InlineCheckboxField)).apply(this, arguments));
  }

  _createClass(InlineCheckboxField, [{
    key: 'onChange',
    value: function onChange(e) {
      var _e$target = e.target,
          name = _e$target.name,
          checked = _e$target.checked,
          _props4 = this.props,
          ApplicationStore = _props4.ApplicationStore,
          application = _props4.application;


      ApplicationStore.update({
        application: application,
        data: _defineProperty({}, name, checked),
        load: false,
        type: application.type
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          application = _props5.application,
          fieldName = _props5.fieldName,
          label = _props5.label;


      return _react2.default.createElement(
        _Col2.default,
        { xs: 6, className: 'inline-checkbox' },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-label', key: fieldName + '-' + application.id + '-label', xs: 4 },
            label
          ),
          _react2.default.createElement(
            _Col2.default,
            { key: fieldName + '-' + application.id, xs: 8 },
            _react2.default.createElement('input', {
              id: fieldName + '-' + application.id,
              name: fieldName,
              type: 'checkbox',
              checked: application[fieldName],
              onChange: this.onChange
            }),
            _react2.default.createElement('label', { htmlFor: fieldName + '-' + application.id })
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return InlineCheckboxField;
}(_react.Component), _class8.propTypes = {
  application: _propTypes2.default.object.isRequired,
  ApplicationStore: _propTypes2.default.object.isRequired,
  fieldName: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string.isRequired
}, _temp5)) || _class7) || _class7) || _class7);
exports.BuyoutField = BuyoutField;
exports.InlineEditField = InlineEditField;
exports.InlineCheckboxField = InlineCheckboxField;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/page-case/main-applications/applicationRenderUtils.js');
  reactHotLoader.register(formatDate, 'formatDate', '/app/src/components/page-case/main-applications/applicationRenderUtils.js');
  reactHotLoader.register(InlineEditField, 'InlineEditField', '/app/src/components/page-case/main-applications/applicationRenderUtils.js');
  reactHotLoader.register(BuyoutField, 'BuyoutField', '/app/src/components/page-case/main-applications/applicationRenderUtils.js');
  reactHotLoader.register(InlineCheckboxField, 'InlineCheckboxField', '/app/src/components/page-case/main-applications/applicationRenderUtils.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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